/*!
=========================================================
* Painel Toca da Onça — Catálogo
=========================================================
* Vitrine com a marca (dourado no preto). Produtos reais do site.
* Clica na foto -> detalhe com várias fotos, descrição e tamanhos.
* Cliente escolhe -> pedido no WhatsApp da loja. Mostra só a foto e o PREÇO de venda.
*/
import React from "react";
import { Row, Col, Input, Button, Badge, Modal, ModalBody } from "reactstrap";
import { supabase } from "supabaseClient";

const OURO = "#FFD700";
const WHATS = "5512991008498";
const brl = (v) => "R$ " + Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 });

function Catalogo() {
  const [produtos, setProdutos] = React.useState([]);
  const [cat, setCat] = React.useState("TODAS");
  const [cesta, setCesta] = React.useState({});
  const [aberto, setAberto] = React.useState(null);
  const [foto, setFoto] = React.useState(0);
  const [tam, setTam] = React.useState("");

  React.useEffect(() => {
    supabase.from("products").select("id,title,price,images,category,sizes,description")
      .eq("status", "active").gt("price", 0).order("views", { ascending: false }).limit(60)
      .then(({ data }) => setProdutos((data || []).filter((p) => Array.isArray(p.images) && p.images[0])));
  }, []);

  const cats = Array.from(new Set(produtos.map((p) => p.category).filter(Boolean))).sort();
  const lista = cat === "TODAS" ? produtos : produtos.filter((p) => p.category === cat);

  const escolher = (p, tamanho) => setCesta((c) => {
    const chave = p.id + (tamanho ? "|" + tamanho : "");
    return { ...c, [chave]: { ...p, tam: tamanho, qtd: (c[chave] ? c[chave].qtd : 0) + 1 } };
  });
  const tirar = (k) => setCesta((c) => { const n = { ...c }; delete n[k]; return n; });
  const itens = Object.entries(cesta);
  const total = itens.reduce((s, [, i]) => s + Number(i.price) * i.qtd, 0);

  const abrir = (p) => { setAberto(p); setFoto(0); setTam(Array.isArray(p.sizes) && p.sizes[0] ? p.sizes[0] : ""); };

  const pedir = () => {
    let msg = "Olá! Quero fazer um pedido na Toca da Onça 🐆%0a%0a";
    itens.forEach(([, i]) => (msg += `• ${i.qtd}x ${i.title}${i.tam ? " (Tam " + i.tam + ")" : ""} — ${brl(i.price)}%0a`));
    msg += `%0a*Total: ${brl(total)}*`;
    window.open(`https://wa.me/${WHATS}?text=${msg}`, "_blank");
  };

  return (
    <div className="content">
      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <h2 style={{ color: OURO, fontWeight: 700, letterSpacing: 2, margin: 0 }}>TOCA DA ONÇA</h2>
        <p className="text-muted" style={{ letterSpacing: 3, margin: 0 }}>CATÁLOGO · MODAS</p>
      </div>

      <Row style={{ marginBottom: 8 }}>
        <Col md="5">
          <Input type="select" value={cat} onChange={(e) => setCat(e.target.value)}>
            <option value="TODAS">Todas as categorias ({produtos.length})</option>
            {cats.map((c) => <option key={c} value={c}>{c}</option>)}
          </Input>
        </Col>
      </Row>

      <Row>
        {lista.map((p) => (
          <Col lg="3" md="4" sm="6" key={p.id} style={{ marginBottom: 20 }}>
            <div style={{ background: "#111", borderRadius: 12, overflow: "hidden", border: "1px solid rgba(255,215,0,.2)", height: "100%" }}>
              <div onClick={() => abrir(p)} style={{ height: 220, cursor: "pointer", background: "#000", backgroundImage: `url(${p.images[0]})`, backgroundSize: "cover", backgroundPosition: "center", position: "relative" }}>
                {p.images.length > 1 && (
                  <span style={{ position: "absolute", top: 8, right: 8, background: "rgba(0,0,0,.6)", color: OURO, borderRadius: 12, padding: "2px 8px", fontSize: 12 }}>
                    <i className="tim-icons icon-image-02" /> {p.images.length}
                  </span>
                )}
              </div>
              <div style={{ padding: 12 }}>
                <p className="text-white" style={{ margin: 0, fontSize: 14, minHeight: 38, lineHeight: 1.3, cursor: "pointer" }} onClick={() => abrir(p)}>{p.title}</p>
                {Array.isArray(p.sizes) && p.sizes.length > 0 && (
                  <p className="text-muted" style={{ margin: "2px 0", fontSize: 12 }}>Tam: {p.sizes.join(" · ")}</p>
                )}
                <p style={{ color: OURO, fontSize: 20, fontWeight: 700, margin: "4px 0" }}>{brl(p.price)}</p>
                <Button block size="sm" style={{ background: OURO, color: "#111", border: "none", fontWeight: 600 }} onClick={() => abrir(p)}>
                  Ver / Escolher
                </Button>
              </div>
            </div>
          </Col>
        ))}
        {lista.length === 0 && <Col xs="12"><p className="text-muted">Carregando produtos do site...</p></Col>}
      </Row>

      <Modal isOpen={!!aberto} toggle={() => setAberto(null)} size="lg" contentClassName="modal-black">
        {aberto && (
          <ModalBody style={{ background: "#0d0d0d", borderRadius: 8, border: "1px solid " + OURO }}>
            <Row>
              <Col md="6">
                <div style={{ height: 340, background: "#000", backgroundImage: `url(${aberto.images[foto]})`, backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center", borderRadius: 8 }} />
                <div style={{ display: "flex", gap: 6, marginTop: 8, flexWrap: "wrap" }}>
                  {aberto.images.map((img, i) => (
                    <div key={i} onClick={() => setFoto(i)} style={{ width: 54, height: 54, borderRadius: 6, cursor: "pointer", background: `#000 url(${img}) center/cover`, border: i === foto ? "2px solid " + OURO : "1px solid #333" }} />
                  ))}
                </div>
              </Col>
              <Col md="6">
                <h4 className="text-white" style={{ marginTop: 0 }}>{aberto.title}</h4>
                <p style={{ color: OURO, fontSize: 26, fontWeight: 700, margin: "6px 0" }}>{brl(aberto.price)}</p>
                {aberto.description && <p className="text-muted" style={{ fontSize: 13, lineHeight: 1.6, maxHeight: 120, overflow: "auto" }}>{aberto.description}</p>}
                {Array.isArray(aberto.sizes) && aberto.sizes.length > 0 && (
                  <div style={{ margin: "10px 0" }}>
                    <p className="text-muted" style={{ margin: "0 0 6px" }}>Tamanho:</p>
                    {aberto.sizes.map((s) => (
                      <Badge key={s} onClick={() => setTam(s)} style={{ cursor: "pointer", marginRight: 6, fontSize: 14, padding: "8px 12px", background: tam === s ? OURO : "rgba(255,255,255,.1)", color: tam === s ? "#111" : "#fff" }}>{s}</Badge>
                    ))}
                  </div>
                )}
                <Button block size="lg" style={{ background: OURO, color: "#111", border: "none", fontWeight: 600, marginTop: 10 }} onClick={() => { escolher(aberto, tam); setAberto(null); }}>
                  Escolher{tam ? " (Tam " + tam + ")" : ""}
                </Button>
              </Col>
            </Row>
          </ModalBody>
        )}
      </Modal>

      {itens.length > 0 && (
        <div style={{ position: "sticky", bottom: 0, background: "#0a0a0a", border: "1px solid " + OURO, borderRadius: 12, padding: 16, marginTop: 10 }}>
          <Row className="align-items-center">
            <Col md="7">
              <p className="text-white" style={{ margin: 0, fontWeight: 600 }}>{itens.length} peça(s) · Total {brl(total)}</p>
              <div style={{ marginTop: 6 }}>
                {itens.map(([k, i]) => (
                  <Badge key={k} style={{ background: "rgba(255,215,0,.15)", color: OURO, marginRight: 6, cursor: "pointer" }} onClick={() => tirar(k)}>
                    {i.qtd}x {i.title.slice(0, 16)}{i.tam ? " " + i.tam : ""} ✕
                  </Badge>
                ))}
              </div>
            </Col>
            <Col md="5">
              <Button block size="lg" style={{ background: "#25d366", color: "#fff", border: "none", fontWeight: 600 }} onClick={pedir}>
                <i className="fab fa-whatsapp" /> Fazer pedido no WhatsApp
              </Button>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
}

export default Catalogo;
